import * as React from 'react';
import { PiralGlobals } from './PiralGlobals';
import { PiralRoutes } from './PiralRoutes';
import { PiralSuspense } from './PiralSuspense';
import { ResponsiveLayout } from './ResponsiveLayout';
import { RegisteredErrorInfo, RegisteredRouteSwitch, RegisteredLayout } from './components';
const NotFound = (props) => React.createElement(RegisteredErrorInfo, { type: "not_found", ...props });
/**
 * The component responsible for the generic view of the application.
 * This includes the used the current content and some convenience.
 */
export const PiralView = ({ breakpoints, children }) => (React.createElement(React.Fragment, null,
    React.createElement(PiralGlobals, null),
    React.createElement(PiralSuspense, null,
        React.createElement(ResponsiveLayout, { breakpoints: breakpoints, Layout: RegisteredLayout },
            React.createElement(PiralRoutes, { NotFound: NotFound, RouteSwitch: RegisteredRouteSwitch }))),
    children));
PiralView.displayName = 'PiralView';
//# sourceMappingURL=PiralView.js.map